// prettier-ignore
export const house = [
  { id: "doorColorTexture", type: "texture", url: "textures/door/color.jpg" },
  { id: "doorAlphaTexture", type: "texture", url: "textures/door/alpha.jpg" },
  { id: "doorAmbientOcclusionTexture", type: "texture", url: "textures/door/ambientOcclusion.jpg" },
  { id: "doorHeightTexture", type: "texture", url: "textures/door/height.jpg" },
  { id: "doorNormalTexture", type: "texture", url: "textures/door/normal.jpg" },
  { id: "doorMetalnessTexture", type: "texture", url: "textures/door/metalness.jpg" },
  { id: "doorRoughnessTexture", type: "texture", url: "textures/door/roughness.jpg" },

  { id: "bricksColorTexture", type: "texture", url: "textures/bricks/diff.jpg" },
  { id: "bricksAoTexture", type: "texture", url: "textures/bricks/ao.jpg" },
  { id: "bricksNormalTexture", type: "texture", url: "textures/bricks/normal.jpg" },
  { id: "bricksRoughnessTexture", type: "texture", url: "textures/bricks/roughness.jpg" },

  { id: "roofColorTexture", type: "texture", url: "textures/roof/diff.jpg" },
  { id: "roofAoTexture", type: "texture", url: "textures/roof/ao.jpg" },
  { id: "roofHeightTexture", type: "texture", url: "textures/roof/height.jpg" },
  { id: "roofNormalTexture", type: "texture", url: "textures/roof/normal.jpg" },
  { id: "roofRoughnessTexture", type: "texture", url: "textures/roof/roughness.jpg" },

  { id: "windowColorTexture", type: "texture", url: "textures/window/diff.jpg" },
  { id: "windowAlphaTexture", type: "texture", url: "textures/window/alpha.jpg" },
  { id: "windowAoTexture", type: "texture", url: "textures/window/ao.jpg" },
  { id: "windowHeightTexture", type: "texture", url: "textures/window/height.png" },
  { id: "windowNormalTexture", type: "texture", url: "textures/window/normal.jpg" },
  { id: "windowMetalnessTexture", type: "texture", url: "textures/window/metalness.jpg" },
  { id: "windowRoughnessTexture", type: "texture", url: "textures/window/roughness.jpg" },

  { id: "grassColorTexture", type: "texture", url: "textures/grass/diff.jpg" },
  { id: "grassAoTexture", type: "texture", url: "textures/grass/ao.jpg" },
  { id: "grassNormalTexture", type: "texture", url: "textures/grass/normal.jpg" },
  { id: "grassRoughnessTexture", type: "texture", url: "textures/grass/roughness.jpg" },

  { id: "grass2ColorTexture", type: "texture", url: "textures/grass2/diff.jpg" },
  { id: "grass2AoTexture", type: "texture", url: "textures/grass2/ao.jpg" },
  { id: "grass2NormalTexture", type: "texture", url: "textures/grass2/normal.jpg" },
  { id: "grass2RoughnessTexture", type: "texture", url: "textures/grass2/roughness.jpg" },

  { id: "gopherTexture", type: "texture", url: "textures/gopher_body.png" },
  { id: "gopherModel", type: "obj", model: "models/Gopher3.obj", material: "models/Gopher3.mtl" },
]
